import { createContext } from "react";

export const SystemContext = createContext({});